import axios from "axios";
import { getHeaders, URL } from "./config";

export const importDnhCategories = async (callback) => {
    const headers = await getHeaders();
    const url = `${URL}/importDnhCategories`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const mergeDnhCategories = async (fromId, toId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/mergeDnhCategories`;
    axios
        .post(url, { fromId, toId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const mergeDnhSubCategories = async (fromId, toId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/mergeDnhSubCategories`;
    axios
        .post(url, { fromId, toId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const triggerDnhImport = async (manufacturer, syncToAlgolia, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/triggerDnhImport?manufacturer=${manufacturer}&syncToAlgolia=${syncToAlgolia}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const updateCategoriesFromExcel = async (filePath, type, previewOnly, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/updateCategoriesFromExcel`;
    const payload = {
        filePath,
        type,
        previewOnly
    };
    
    axios
        .post(url, payload, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.response?.data?.message || error?.message });
        });
};

